"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteWidgetPanel = void 0;
const selectors_1 = require("../../exports/store/selectors");
const command_manager_1 = require("../../command_manager");
const datasheet_1 = require("../../model/datasheet");
exports.deleteWidgetPanel = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { deletePanelId, resourceType, resourceId } = options;
        const widgetPanels = (0, selectors_1.getResourceWidgetPanels)(state, resourceId, resourceType);
        if (!widgetPanels) {
            return null;
        }
        const panel = widgetPanels.find(item => item.id === deletePanelId);
        if (!panel) {
            return null;
        }
        const deleteWidgetPanelAction = datasheet_1.DatasheetActions.deleteWidgetPanel2Action(state, deletePanelId, widgetPanels, resourceType);
        if (!deleteWidgetPanelAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: resourceId,
            resourceType: resourceType,
            actions: deleteWidgetPanelAction,
        };
    },
};
//# sourceMappingURL=delete_widget_panel.js.map